
export class pointInArea {

    // 多角形の内分点判定
    static _unit: number = 1 / (2 * Math.PI);
    /// 調査点
    /// positions 多角形を構成する頂点リスト
    /// normal 多角形が存在する平面の法線
    /// 調査点が内側にある場合はtrue
    static pointInArea(target: THREE.Vector2, positions: THREE.Vector2[]): boolean {
        let result = 0;

        for (let i = 0; i < positions.length; i++) {
            const p1 = positions[i].clone();
            const p2 = positions[(i + 1) % positions.length].clone();
            const l1 = p1.sub(target).normalize();
            const l2 = p2.sub(target).normalize()

            let rad = Math.acos(l1.dot(l2));
            const cross = l1.cross(l2);
            if (cross < 0.0) {
                rad *= -1;
            }
            result += rad;
        }
        result *= this._unit;
        // 時計回り・反時計回りどちらもありえるため絶対値で判定する
        return Math.abs(result) >= 0.01;
    }
}

